import { VideoBackdrop } from "../components/VideoBackdrop";
import { EMBLEM, HERO_VIDEO } from "../data/site";

export function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-[#141414] px-6 py-28 text-center"
    >
      {/* Ocean video with a dark overlay to keep the emblem and headline legible */}
      <VideoBackdrop
        src={HERO_VIDEO}
        testId="hero-video"
        overlayClass="bg-gradient-to-b from-[#141414]/60 via-[#141414]/45 to-[#141414]/70"
      />

      <div className="relative z-10 flex flex-col items-center">
        <img
          src={EMBLEM}
          alt="Raintree Holdings emblem"
          data-testid="hero-emblem"
          className="h-[288px] w-auto sm:h-[374px] lg:h-[432px]"
        />
        <h1
          data-testid="hero-headline"
          className="mt-16 text-[clamp(2rem,6.2vw,4.6rem)] font-semibold leading-[1.05] tracking-[-0.02em]"
        >
          <span className="block text-[#A27B5B]">We built companies.</span>
          <span className="block text-[#DCD7C9]">Now we back them.</span>
        </h1>
        <p
          data-testid="hero-subline"
          className="mt-7 text-base leading-relaxed text-[#DCD7C9]/70 sm:text-lg"
        >
          Raintree is a private holding company
          <br />
          in coastal British Columbia.
        </p>
        <p
          data-testid="hero-established"
          className="mt-6 text-[0.72rem] font-medium uppercase tracking-[0.32em] text-[#DCD7C9]/55"
        >
          Established 2006
        </p>
      </div>
    </section>
  );
}
